import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getAnalytics } from 'firebase/analytics';

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyAMm5ixhUx7lEFtqLLEqYP1hX79810GwVo",
  authDomain: "fighter-bet-plus.firebaseapp.com",
  projectId: "fighter-bet-plus",
  storageBucket: "fighter-bet-plus.firebasestorage.app",
  messagingSenderId: "687580047545",
  appId: "1:687580047545:web:34823ff6aa33e6fa7a9368",
  measurementId: "G-C8ZEC00ZTP"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase Authentication and get a reference to the service
export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();

// Initialize Cloud Firestore and get a reference to the service
export const db = getFirestore(app);

// Initialize Firebase Storage and get a reference to the service
export const storage = getStorage(app);

// Initialize Analytics
export const analytics = getAnalytics(app);

export default app;
